var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_15021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.383384 8.89222C0.382965 10.4046 0.778128 11.8813 1.52952 13.1828L0.311523 17.63L4.86259 16.4367C6.12136 17.1219 7.53171 17.481 8.96492 17.4811H8.96869C13.7 17.4811 17.5513 13.6311 17.5534 8.89899C17.5543 6.60594 16.6621 4.44971 15.0411 2.82748C13.4204 1.20538 11.2649 0.311593 8.96834 0.310547C4.2365 0.310547 0.385407 4.16031 0.383454 8.89222",
    fill: "url(#paint0_linear_761_15021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0766043 8.88949C0.0761159 10.4563 0.485441 11.9858 1.26363 13.334L0.00195312 17.9405L4.71621 16.7044C6.01514 17.4126 7.4776 17.786 8.96574 17.7866H8.96958C13.8706 17.7866 17.8603 13.7981 17.8624 8.8966C17.8633 6.52116 16.939 4.28742 15.2601 2.60707C13.581 0.92693 11.3484 0.000976744 8.96958 0C4.06772 0 0.0785578 3.98791 0.0766043 8.88949ZM2.88405 13.1018L2.70802 12.8223C1.96807 11.6458 1.57751 10.2862 1.57807 8.89005C1.57967 4.81598 4.8953 1.5014 8.97237 1.5014C10.9468 1.50223 12.8023 2.27191 14.198 3.66837C15.5935 5.06498 16.3614 6.92149 16.361 8.89605C16.3591 12.9701 13.0434 16.2851 8.96958 16.2851H8.96665C7.64016 16.2844 6.33921 15.9282 5.20465 15.255L4.93465 15.0949L2.13712 15.8283L2.88405 13.1017V13.1018Z",
    fill: "url(#paint1_linear_761_15021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74722 5.17304C6.58075 4.80306 6.40557 4.79559 6.24726 4.78911C6.11764 4.78352 5.96945 4.78394 5.8214 4.78394C5.67322 4.78394 5.43245 4.83969 5.22894 5.0619C5.02522 5.28431 4.45117 5.8218 4.45117 6.91499C4.45117 8.00824 5.24743 9.06473 5.35843 9.21313C5.46957 9.36125 6.89561 11.6764 9.15413 12.5671C11.0311 13.3072 11.4131 13.16 11.8205 13.1229C12.2279 13.0859 13.1352 12.5855 13.3203 12.0667C13.5055 11.5479 13.5055 11.1032 13.45 11.0103C13.3945 10.9177 13.2463 10.8621 13.0241 10.751C12.8018 10.6399 11.7094 10.1023 11.5057 10.0282C11.302 9.95406 11.1539 9.91708 11.0057 10.1396C10.8575 10.3617 10.432 10.8621 10.3023 11.0103C10.1727 11.1588 10.043 11.1773 9.82089 11.0662C9.59854 10.9547 8.88294 10.7203 8.03394 9.96341C7.37338 9.37443 6.92743 8.64711 6.7978 8.42462C6.66817 8.20248 6.78392 8.08206 6.89533 7.97134C6.99517 7.87178 7.11761 7.71187 7.22882 7.58218C7.33961 7.45241 7.37659 7.35983 7.45068 7.21164C7.52485 7.06331 7.48773 6.93355 7.43227 6.82241C7.37659 6.71127 6.9448 5.61236 6.74722 5.17304Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_761_15021",
    x1: 862.403,
    y1: 1732.25,
    x2: 862.403,
    y2: 0.310547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_761_15021",
    x1: 893.025,
    y1: 1794.05,
    x2: 893.025,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_15021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.865,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.380a908daf684044f6657c9ae78f3d15.svg";
export { ForwardRef as ReactComponent };